import { IconContent } from '@icons';

export const locations: IconContent = {
    md: '<g><path fill-rule="evenodd" d="M12 19.6c4-2.4 6-6 6-9.4a6 6 0 0 0-12 0c0 3.4 2 7 6 9.4Zm0 1.1c4.5-2.4 7-6.6 7-10.4a7 7 0 1 0-14 0c0 3.8 2.5 8 7 10.4Z" clip-rule="evenodd"/><path d="M14 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"/></g>',
};
